import type {
  CheckoutCommonReduxState,
  CheckoutReduxStateV2
} from "@app/types/checkout-v2-types";
import type { NapiV2Cart } from "@app/types/napi-v2-cart-types";
import type { TicketCharges } from "@app/types/napi-v2-charges-types";
import type { ResultsCartState } from "@app/types/results-cart-types";
import type { ResultsReduxState } from "@app/types/results-redux-types";

export const getCartTicketChargesItems = (
  state: CheckoutReduxStateV2 | CheckoutCommonReduxState | ResultsReduxState
) => {
  // ResultsCartState is the one used for Async Cart
  if (!state.cart || (isResultsCartState(state.cart) && !state.cart.cart)) {
    return [];
  }

  const cart: NapiV2Cart = isResultsCartState(state.cart)
    ? state.cart.cart!
    : state.cart;

  if (!cart.charges?.items) {
    return [];
  }

  return cart.charges.items.filter(
    item => item.type === "ticket"
  ) as TicketCharges[];
};

function isResultsCartState(
  cart: NapiV2Cart | ResultsCartState
): cart is ResultsCartState {
  return "cart" in cart;
}
